import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import { FinalTableConfig } from "@beeldit/core/models/FinalTableConfig.interface";
import {
  DownloadSimple,
  Export,
  Eye,
  PencilSimple,
  Plus,
  SignIn,
  Trash,
} from "@phosphor-icons/react";
import { labelValue } from "@rjsf/utils";

const tableConfig: FinalTableConfig = {
  index: null,
  actions: [
    {
      name: TableAction.CREATE,
      label: "create_combination",
      showLabel: true,
      allowed: true,
      show: true,
      action: null,
      variant: "primary",
      icon: <Plus size={20} />,
    },
  ],
  rowActions: [
    {
      name: RowAction.DETAILS,
      label: "edit",
      icon: <Eye size={20} />,
      allowed: true,
      show: false,
      action: (element: any) => {
        console.log("edit", element);
      },
    },
    {
      name: RowAction.EDIT,
      label: "edit",
      icon: <PencilSimple size={20} />,
      allowed: true,
      show: true,
      action: (element: any) => {
        console.log("edit", element);
      },
    },
    {
      name: RowAction.DELETE,
      label: "delete",
      icon: <Trash size={20} />,
      allowed: true,
      show: true,
      action: (element: any) => {
        console.log("delete", element);
      },
    },
  ],
  rowConfiguration: {
    class: (element: any) => {
      return null;
    },
  },
  columns: [
    {
      name: "id",
      label: "#",
      key: "id",
      type: "number",
      show: true,
      sortable: true,
    },
    {
      name: "attributes",
      label: "combination_main_attribute",
      key: "attributes",
      attribute: "pivot.value",
      type: "array-first-element",
      show: true,
      sortable: false,
    },
    {
      name: "name",
      label: "name",
      key: "name.es",
      type: "string",
      show: true,
      sortable: true,
    },
    {
      name: "stock",
      label: "stock",
      key: "stock",
      type: "number",
      show: true,
      sortable: true,
    },
    {
      name: "price",
      label: "price",
      key: "price",
      type: "currency",
      currency: "EUR",
      show: true,
      sortable: true,
    },
    {
      name: "tax",
      label: "tax",
      key: "tax",
      type: "currency",
      currency: "EUR",
      show: true,
      sortable: true,
    },
    {
      name: "sku",
      label: "sku",
      key: "sku",
      type: "string",
      show: true,
      sortable: true,
    },
    {
      name: "role_segment",
      label: "role_segment",
      key: "role_segment",
      type: "translation",
      translation_prefix: "role_segment",
      show: true,
      sortable: true,
    },
  ],
  pagination: {
    enabled: true,
    back: true,
  },
};
const getConfig: any = (functions: any) => {
  const {
    getFunction,
    indexFunction,
    initializeFunction,
    prepareRemoveFunction,
    detailsFunction,
  } = functions;
  tableConfig.actions[0].action = () => initializeFunction();
  tableConfig.index = () => indexFunction();
  tableConfig.rowActions[0].action = (id: any) => detailsFunction(id);
  tableConfig.rowActions[1].action = (id: any) => getFunction(id);
  tableConfig.rowActions[2].action = (id: any) => prepareRemoveFunction(id);
  return tableConfig;
};
export default getConfig;
